<template>
  <div class="input-group">
    <datetime
      class="form-group"
      v-model="value"
      :input-id="fieldID"
      :input-class="' form-control'"
      :type="pickerType"
      :minute-step="fieldOptions.minuteStep"
      :auto="fieldOptions.auto !== undefined ? fieldOptions.auto : true"
    >
    </datetime>
    <div class="input-group-addon">
      <i class="fa fa-calendar"></i>
    </div>
  </div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import moment from 'moment';
// import dateFieldHelper from "vue-form-generator/src/utils/dateFieldHelper"

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

const inputFormat = 'YYYY-MM-DDTHH:mm:ssZ';

export default {
  mixins: [VueFormGenerator.abstractField],
  computed: {
    pickerType() {
      return (this.schema.fieldOptions && this.schema.fieldOptions.type) || 'datetime';
    },
  },
  methods: {
    // getDateFormat() {
    //   if (this.schema.fieldOptions && this.schema.fieldOptions.format) return this.schema.fieldOptions.format;
    //   return inputFormat;
    // },

    getDefaultInputFormat() {
      return inputFormat;
    },
    getDateFormat() {
      if (typeof this.fieldOptions.format !== 'undefined') {
        return this.fieldOptions.format;
      }
      return this.getDefaultInputFormat();
    },
    formatValueToField(value) {
      if (value != null) {
        let dt;
        if (typeof this.fieldOptions.format !== 'undefined') {
          dt = moment(value, this.fieldOptions.format).toDate();
        } else {
          dt = new Date(value);
        }
        return moment(dt).format(this.getDateFormat());
      }

      return value;
    },

    formatValueToModel(value) {
      if (value != null) {
        const m = moment(value, this.getDateFormat());
        value = m.format(this.getDateFormat());
      }
      return value;
    },
  },

  mounted() {
    this.$nextTick(() => {});
  },

  beforeDestroy() {},
};
</script>

<style lang="scss">
.vdatetime.form-group {
  margin-bottom: 0;
}
</style>
